import * as React from "react";
const SvgHomeFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.293 2.293a1 1 0 0 1 1.414 0l8 8A1 1 0 0 1 21 11v10a1 1 0 0 1-1 1h-4.993a1 1 0 0 1-1-1v-5H10v5a1 1 0 0 1-.883.993L9 22H4a1 1 0 0 1-1-1V11a1 1 0 0 1 .293-.707z", clipRule: "evenodd" }));
export default SvgHomeFill;
